const RunIcon = () => {
	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			stroke="currentColor"
			fill="#177a1f"
			x="0px"
			y="0px"
			viewBox="0 0 32 32"
			height="1.5em"
			width="1.5em"
			// @ts-ignore
			style={ { enableBackground: 'new 0 0 32 32' } }
		>
			<path
				d="M26.9,15.7C26.8,15.3,26.4,15,26,15h-6l3.9-11.7c0.1-0.4,0-0.9-0.4-1.1c-0.4-0.3-0.8-0.2-1.2,0l-17,13
	c-0.3,0.3-0.5,0.7-0.3,1.1C5.2,16.7,5.6,17,6,17h6L8.1,28.7c-0.1,0.4,0,0.9,0.4,1.1C8.6,29.9,8.8,30,9,30c0.2,0,0.4-0.1,0.6-0.2
	l17-13C26.9,16.5,27.1,16.1,26.9,15.7z"
			/>
		</svg>
	);
};
export default RunIcon;
